import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import ProductCarouselSection from 'Containers/HomePage/ProductCarouselSection';
import { fetchBySlugs } from 'Redux/ducks/algolia-calls';


const messages = defineMessages({
  asterixProducts: {
    id: 'AsterixProducts',
    defaultMessage: 'Asterix and Obelix Omnibus',
  },
});

const AsterixProducts = () => {
  const fetchHits = async () => {
    const results = await fetchBySlugs([['asterix-omnibus-vol-1', 'asterix-omnibus-vol-2', 'asterix-omnibus-vol-3']]);

    return results?.[0] || [];
  };

  const { formatMessage } = useIntl();
  return (
    <ProductCarouselSection
      sectionCss="AsterixProducts"
      title={formatMessage(messages.asterixProducts)}
      hitCardNameTag="h3"
      slidesToShow={3}
      lgSize={4}
      fetchHits={fetchHits}
      headingTag="h1"
    />
  );
};

export default AsterixProducts;
